var React = require('react');

function Betslip (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Icons","transform":"translate(-268.000000, -840.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"betslip","transform":"translate(268.000000, 840.000000)"},React.createElement("path",{"d":"M2.75862069,0 C1.54388115,0.00522913305 0.562193193,0.89912987 0.562206897,2 L0.551172414,20 L8.27531034,17 L15.9994483,20 L15.9994483,2 C15.9958142,0.896992543 15.0102142,0.00356915135 13.7931034,0 L2.75862069,0 Z M13.7931034,17 L8.27586207,14.8195 L2.75862069,17 L2.75862069,2 L13.7931034,2 L13.7931034,17 L13.7931034,17 Z","id":"betslip_icon"}))))]);
}

Betslip.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20","version":"1.1"};

module.exports = Betslip;

Betslip.default = Betslip;
